import { Component } from '@angular/core';
import { SPRINT_PAY_FLEX_SLOGAN } from 'src/app/shared/utils/constants';

@Component({
    selector: 'app-rnpl-slogan',
    standalone: true,
    templateUrl: './rnpl-slogan.component.html',
    styleUrls: ['./rnpl-slogan.component.scss'],
})
export class RnplSloganComponent {
    protected readonly slogan = SPRINT_PAY_FLEX_SLOGAN;
}
